import React from "react";
import { Box, Button, Chip } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import DownloadIcon from '@mui/icons-material/Download';
import MainWithoutResult from "../../General/MainWithoutResult";
import { colors } from "../../../../assets/colors";

const BodyDeclaracion = ({ historial, onConsultar }) => {

  const obtenerChipEstado = (estado) => {
    switch (estado) {
      case "PROCESADO":
      case "CONSTANCIAS_DISPONIBLES":
        return <Chip label={estado} size="small" color="success" />;
      case "EN_PROCESO":
        return <Chip label="En Proceso" size="small" color="warning" />;
      case "ERROR":
      case "RECHAZADO":
        return <Chip label={estado} size="small" color="error" />;
      default:
        return <Chip label={estado || "Desconocido"} size="small" color="default" />;
    }
  };

  return (
    <Box className="page-body-main">
      <Box className="page-body-table table-responsive-md">
        <table className="table table-hover table-striped table-bordered">
          <thead
            className="sticky-top"
            style={{
              backgroundColor: colors.quaternary.hex,
              color: "#fff",
              whiteSpace: "nowrap",
            }}
          >
            <tr>
              <th style={{ width: 150 }}>Fecha de Envío</th>
              <th>ID Trámite API</th>
              <th>Seguro</th>
              <th>Modalidad</th>
              <th style={{ width: 130, textAlign: "center" }}>Enviados</th>
              <th style={{ width: 150, textAlign: "center" }}>Estado</th>
              <th style={{ width: 180, textAlign: "center" }}>Acciones</th>
            </tr>
          </thead>

          <tbody>
            {historial.map((row) => (
              <tr key={row.id_local}>
                <td>{row.fecha_envio}</td>
                <td>{row.tramiteId_api || "N/A"}</td>
                <td>{row.seguro}</td>
                <td>
                  <Chip 
                    label={row.modalidad === 'MES_ADELANTADO' ? 'Adelantado' : 'Vencido'} 
                    size="small" 
                    variant="outlined" 
                  />
                </td>
                <td align="center">
                  <b>{row.total_enviados}</b>
                </td>
                <td align="center">
                  {obtenerChipEstado(row.estado)}
                </td>
                <td align="center">
                  
                  {row.estado === "EN_PROCESO" && (
                    <Button
                      variant="contained"
                      color="warning"
                      size="small"
                      startIcon={<SearchIcon />}
                      onClick={() => onConsultar(row.tramiteId_api)}
                    >
                      Consultar API
                    </Button>
                  )}

                  {(row.estado === "CONSTANCIAS_DISPONIBLES" || row.estado === "PROCESADO") && (
                     <Button
                     variant="contained"
                     color="success"
                     size="small"
                     startIcon={<DownloadIcon />}
                     onClick={() => onConsultar(row.tramiteId_api)}
                   >
                     Descargar PDF
                   </Button>
                  )}

                </td>
              </tr>
            ))}

            {historial.length === 0 && (
              <tr>
                <td colSpan="7">
                  <MainWithoutResult />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </Box>
    </Box>
  );
};

export default BodyDeclaracion;